<template>
  <v-card>
    <v-row no-gutters class="pt-2"  justify="end">
      <v-btn color="color-grey" depressed right text small @click="$emit('close')">
        <v-icon class="mr-3">fa-times</v-icon>
        <span>{{ $t('close') }}</span>
      </v-btn>
    </v-row>
    <v-container class="pt-0" fluid>
      <v-row justify="center">
        <v-col class="text-center" cols="12">
          <h4 class="mt-0 text-h4">{{ $t('debtorPaymentInfo') }}</h4>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="9">
          <p class="mb-0">{{ $t('overpaymentNeededText') }}</p>
          <p>{{ $t('overPaymentChargeText') }} {{ 5 | currency }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" md="6">
              <p class="ok-title color-new-link-blue--text">{{ $t('debtorBankAccNo') }}</p>
              <v-form ref="ibanForm" v-model="ibanValid">
                <v-text-field label="IBAN"
                              v-model="iban.iban"
                              :rules="ibanRules">
                </v-text-field>
              </v-form>
            </v-col>
            <v-col cols="12" md="6">
              <p class="ok-title color-new-link-blue--text">{{ $t('bicCode') }}</p>
              <v-form ref="bicForm">
                <v-text-field label="BIC"
                              readonly
                              disabled
                              v-model="iban.bic"
                              :rules="bicRules">
                </v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row justify="center">
        <div class="pa-3">
          <v-btn tile class="primary" @click="addIbanInfo(iban)" :disabled="!ibanValid">{{ $t('addBankAccNo') }}</v-btn>
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    data: function () {
      return {
        iban: {
          iban: '',
          bic: ''
        },
        ibanValid: false,
        ibanRules: [
          v => v !== undefined && this.isIbanValid(v) || this.$t('validIbanMsg')
        ],
        bicRules: [
          v => v !== undefined && v.length > 0 || 'Valitettavasti tilinumeroa ei voinut lisätä. Ota yhteyttä asiakaspalveluun'
        ],
        bicCodes: [
          { id: '796', code: 'NARYFIH2' },
          { id: '714', code: 'EVSEFIHH' },
          { id: '713', code: 'CITIFIHX' },
          { id: '711', code: 'BSUIFIHH' },
          { id: '8', code: 'DABAFIHH' },
          { id: '34', code: 'DABAFIHH' },
          { id: '37', code: 'DNBAFIHX' },
          { id: '31', code: 'HANDFIHH' },
          { id: '715', code: 'ITELFIHH' },
          { id: '400', code: 'ITELFIHH' },
          { id: '402', code: 'ITELFIHH' },
          { id: '403', code: 'ITELFIHH' },
          { id: '406', code: 'ITELFIHH' },
          { id: '407', code: 'ITELFIHH' },
          { id: '408', code: 'ITELFIHH' },
          { id: '410', code: 'ITELFIHH' },
          { id: '411', code: 'ITELFIHH' },
          { id: '412', code: 'ITELFIHH' },
          { id: '414', code: 'ITELFIHH' },
          { id: '415', code: 'ITELFIHH' },
          { id: '416', code: 'ITELFIHH' },
          { id: '417', code: 'ITELFIHH' },
          { id: '418', code: 'ITELFIHH' },
          { id: '419', code: 'ITELFIHH' },
          { id: '420', code: 'ITELFIHH' },
          { id: '421', code: 'ITELFIHH' },
          { id: '423', code: 'ITELFIHH' },
          { id: '424', code: 'ITELFIHH' },
          { id: '425', code: 'ITELFIHH' },
          { id: '426', code: 'ITELFIHH' },
          { id: '427', code: 'ITELFIHH' },
          { id: '428', code: 'ITELFIHH' },
          { id: '429', code: 'ITELFIHH' },
          { id: '430', code: 'ITELFIHH' },
          { id: '431', code: 'ITELFIHH' },
          { id: '432', code: 'ITELFIHH' },
          { id: '435', code: 'ITELFIHH' },
          { id: '436', code: 'ITELFIHH' },
          { id: '437', code: 'ITELFIHH' },
          { id: '438', code: 'ITELFIHH' },
          { id: '439', code: 'ITELFIHH' },
          { id: '440', code: 'ITELFIHH' },
          { id: '441', code: 'ITELFIHH' },
          { id: '442', code: 'ITELFIHH' },
          { id: '443', code: 'ITELFIHH' },
          { id: '444', code: 'ITELFIHH' },
          { id: '445', code: 'ITELFIHH' },
          { id: '446', code: 'ITELFIHH' },
          { id: '447', code: 'ITELFIHH' },
          { id: '448', code: 'ITELFIHH' },
          { id: '449', code: 'ITELFIHH' },
          { id: '450', code: 'ITELFIHH' },
          { id: '451', code: 'ITELFIHH' },
          { id: '452', code: 'ITELFIHH' },
          { id: '454', code: 'ITELFIHH' },
          { id: '455', code: 'ITELFIHH' },
          { id: '456', code: 'ITELFIHH' },
          { id: '457', code: 'ITELFIHH' },
          { id: '458', code: 'ITELFIHH' },
          { id: '459', code: 'ITELFIHH' },
          { id: '460', code: 'ITELFIHH' },
          { id: '461', code: 'ITELFIHH' },
          { id: '462', code: 'ITELFIHH' },
          { id: '463', code: 'ITELFIHH' },
          { id: '464', code: 'ITELFIHH' },
          { id: '483', code: 'ITELFIHH' },
          { id: '484', code: 'ITELFIHH' },
          { id: '485', code: 'ITELFIHH' },
          { id: '486', code: 'ITELFIHH' },
          { id: '487', code: 'ITELFIHH' },
          { id: '488', code: 'ITELFIHH' },
          { id: '489', code: 'ITELFIHH' },
          { id: '490', code: 'ITELFIHH' },
          { id: '491', code: 'ITELFIHH' },
          { id: '492', code: 'ITELFIHH' },
          { id: '493', code: 'ITELFIHH' },
          { id: '495', code: 'ITELFIHH' },
          { id: '496', code: 'ITELFIHH' },
          { id: '1', code: 'NDEAFIHH' },
          { id: '2', code: 'NDEAFIHH' },
          { id: '5', code: 'OKOYFIHH' },
          { id: '33', code: 'ESSEFIHX' },
          { id: '36', code: 'SBANFIHH' },
          { id: '39', code: 'SBANFIHH' },
          { id: '38', code: 'SWEDFIHH' },
          { id: '405', code: 'HELSFIHH' },
          { id: '497', code: 'HELSFIHH' },
          { id: '6', code: 'AABAFI22' },
          { id: '470', code: 'POPFFI22' },
          { id: '471', code: 'POPFFI22' },
          { id: '472', code: 'POPFFI22' },
          { id: '473', code: 'POPFFI22' },
          { id: '474', code: 'POPFFI22' },
          { id: '475', code: 'POPFFI22' },
          { id: '476', code: 'POPFFI22' },
          { id: '477', code: 'POPFFI22' },
          { id: '478', code: 'POPFFI22' },
          { id: '479', code: 'POPFFI22' },
          { id: '717', code: 'BIGKFIH1' },
          { id: '797', code: 'TRYEFIH2' },
          { id: '798', code: 'VPAYFIH2' },
          { id: '799', code: 'HOLVFIHH' }
        ],
        loading: false
      }
    },
    methods: {
      isIbanValid (iban) {
        if (iban === undefined || iban == null) {
          return false
        } else {
          iban = iban.replace(/\s/g, '')
          if (iban.length === 18) {
            let ibanStartsWith = iban.substring(0, 2).toUpperCase()
            if (ibanStartsWith === 'FI') {
              let tmp = iban.substring(4, 18) + '1518' + iban.substring(2, 4)
              let checksum = tmp.slice(0, 2)
              for (let offset = 2; offset < tmp.length; offset += 7) {
                let fragment = String(checksum) + tmp.substring(offset, offset + 7)
                checksum = parseInt(fragment, 10) % 97
              }
              if (checksum === 1) {
                this.loadBic(iban.substring(4, 7))
                return true
              } else {
                return false
              }
            }
          } else {
            return false
          }
        }
      },
      loadBic (bankInstitutionCode) {
        let loadedBic
        this.bicCodes.forEach(function (param) {
          if (param.id === bankInstitutionCode) {
            loadedBic = param.code
          } else if (param.id === bankInstitutionCode.substring(0, 2)) {
            loadedBic = param.code
          } else if (param.id === bankInstitutionCode.substring(0, 1)) {
            loadedBic = param.code
          }
        }
        )
        this.iban.bic = ''
        this.iban.bic = loadedBic
      },
      addIbanInfo (iban) {
        let payload = { iban: iban.iban, bic: iban.bic }
        if (this.$refs.ibanForm.validate() && this.$refs.bicForm.validate()) {
          this.$store.dispatch('addIbanInfo', payload)
          this.$emit('close')
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "debtorPaymentInfo": "Ylisuorituksen palautus",
  "debtorBankAccNo": "Tilinumero (IBAN)",
  "bicCode": "PANKIN TUNNUS (BIC)",
  "addBankAccNo": "Lisää IBAN",
  "overpaymentNeededText": "Tilinumeroasi käytetään ainoastaan tämän ylisuorituksen palautusta varten.",
  "validIbanMsg": "Varmista että tilinumero on oikeassa muodossa",
  "overPaymentChargeText": "Palautusmaksusta veloitamme:"
  },
  "se": {
  "debtorPaymentInfo": "Returnering av överbetalning",
  "debtorBankAccNo": "Kontonummer(IBAN)",
  "bicCode": "BIC kod",
  "addBankAccNo": "Lägg till IBAN",
  "overpaymentNeededText": "Ditt kontonummer används endast för returnering av denna överbetalning.",
  "validIbanMsg": "Varmista että IBAN on oikeassa muodossa",
  "overPaymentChargeText": "För returneringen debiterar vi:"
  },
  "en": {
  "debtorPaymentInfo": "Overpayment refund",
  "debtorBankAccNo": "Bank account number(IBAN)",
  "bicCode": "Bank identification code (BIC)",
  "addBankAccNo": "Add IBAN",
  "overpaymentNeededText": "Your account number is only used for the refund of this overpayment.",
  "validIbanMsg": "Give a valid IBAN",
  "overPaymentChargeText": "For refundment we charge:"
  }
  }
</i18n>
